import { render, staticRenderFns } from "./AcknowledgementAndConsent.vue?vue&type=template&id=665d1a26"
import script from "./AcknowledgementAndConsent.vue?vue&type=script&lang=js"
export * from "./AcknowledgementAndConsent.vue?vue&type=script&lang=js"
import style0 from "./AcknowledgementAndConsent.vue?vue&type=style&index=0&id=665d1a26&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('665d1a26')) {
      api.createRecord('665d1a26', component.options)
    } else {
      api.reload('665d1a26', component.options)
    }
    module.hot.accept("./AcknowledgementAndConsent.vue?vue&type=template&id=665d1a26", function () {
      api.rerender('665d1a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/modals/AcknowledgementAndConsent.vue"
export default component.exports